import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    disabled?: boolean;
}

// Outgoing functions
interface IDispatch {
    onClick: () => void
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const DisableButton = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('common');

    return (
        <Button 
            startIcon={<PauseCircleOutlineIcon />} 
            disabled={props.disabled} 
            onClick={props.onClick} 
            variant="contained" 
            color="default"
        >
            {t('disable')}
        </Button>
    )
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));
